// Review Scroll Functionality
document.addEventListener("DOMContentLoaded", function () {
  // Watch for clicks on the star rating
  document.querySelectorAll('.jdgm-prev-badge, .jdgm-widget-title').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      // Activate the third tab (adjust the selector based on your theme)
      const tabButtons = document.querySelectorAll('.product-tabs .tab-button');
      const tabContents = document.querySelectorAll('.product-tabs .tab-content');

      if (tabButtons.length >= 3) {
        // Remove active class from all tabs
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Add active class to the third tab
        tabButtons[2].classList.add('active');
        tabContents[2].classList.add('active');

        // Now scroll to the review section
        const reviewWidget = document.getElementById('judgeme_product_reviews');
        if (reviewWidget) {
          setTimeout(function () {
            reviewWidget.scrollIntoView({ behavior: 'smooth' });
          }, 300); // slight delay to allow tab to open first
        }
      }
    });
  });
});

/* Header menus on hover */
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
//console.log(items)
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const variantInput = document.querySelector('input[name="id"]');
  const priceSpan = document.querySelector(
    "#price-button-" +
      document
        .querySelector('[id^="ProductSubmitButton-"]')
        ?.id?.split("ProductSubmitButton-")[1]
  );

  if (!variantInput || !priceSpan) return;

  fetch(window.location.pathname + ".js")
    .then((res) => res.json())
    .then((product) => {
      const updatePrice = () => {
        const variantId = variantInput.value;
        const selectedVariant = product.variants.find((v) => v.id == variantId);

        if (selectedVariant) {
          const price = (selectedVariant.price / 100).toFixed(2);
          priceSpan.innerText = `- $${price}`;
        } else {
          priceSpan.innerText = "";
        }
      };

      // Monitor input[name="id"] value change
      const observer = new MutationObserver(updatePrice);
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ["value"],
      });

      // Also bind to change event just in case
      variantInput.addEventListener("change", updatePrice);

      // Initial update
      updatePrice();
    });
});

/* Sliders */
$(document).ready(function () {
  $(".testimonial-slider-main").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 2000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  });
});
 document.addEventListener("DOMContentLoaded", function () {
    $(".blog-posts-cm-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 300,
      infinite: true,
      autoplaySpeed: 5000,
      autoplay: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
          },
        },
      ],
    });
  });


/**Product Gallery Slider***/

  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.thumbnail-list'); // No class or ID changed
    const prevBtn = document.querySelector('.slider-button--prev');
    const nextBtn = document.querySelector('.slider-button--next');

    console.log("Slider found: ", slider);
    console.log("Prev Button found: ", prevBtn);
    console.log("Next Button found: ", nextBtn);

    if (slider && prevBtn && nextBtn) {
      const scrollAmount = 120; // Change this value based on thumbnail height

      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        console.log("Prev button clicked");
        slider.scrollBy({
          top: -scrollAmount,
          behavior: 'smooth'
        });
      });

      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        console.log("Next button clicked");
        slider.scrollBy({
          top: scrollAmount,
          behavior: 'smooth'
        });
      });
    } else {
      console.warn('One or more elements not found');
    }
  });



/***Main-product Decription button***/
 function toggleDescription(link) {
    const shortDesc = link.previousElementSibling.previousElementSibling;
    const fullDesc = link.previousElementSibling;

    const isExpanded = fullDesc.style.display === 'block';

    if (isExpanded) {
      fullDesc.style.display = 'none';
      shortDesc.style.display = 'block';
      link.textContent = 'View More';
    } else {
      fullDesc.style.display = 'block';
      shortDesc.style.display = 'none';
      link.textContent = 'View Less';
    }
  }





